import { Plugins } from '@leverege/plugin';
import ExportModel from './ExportModel.js';
import ExportEditor from "./ExportEditor.js";
import ExportFormatterPlugins from './exportFormatter/PluginSetup.js';
export default {
  install: opts => {
    Plugins.add('Model', {
      type: ExportModel.TYPE,
      model: ExportModel
    });
    Plugins.add('ModelEditor', {
      type: ExportModel.TYPE,
      editor: ExportEditor
    });
    ExportFormatterPlugins.install(opts);
  }
};